import { useEffect, useState } from "react";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";
import { Star } from "lucide-react";

function ReviewCard({ r }) {
  return (
    <div className="w-80 shrink-0 card-soft p-6 mx-2">
      <div className="flex items-center gap-3">
        <span className="w-11 h-11 rounded-full brand-gradient text-white flex items-center justify-center font-bold font-heading">
          {r.name.charAt(0)}
        </span>
        <div>
          <p className="font-semibold text-sm">{r.name}</p>
          <p className="text-xs text-neutral-400">{r.date}</p>
        </div>
        <img src="https://www.gstatic.com/images/branding/product/1x/googleg_48dp.png" alt="Google" className="w-5 h-5 ml-auto" loading="lazy" />
      </div>
      <div className="flex gap-0.5 mt-3">
        {Array.from({ length: r.rating }).map((_, k) => <Star key={k} size={14} className="fill-brand-amber text-brand-amber" />)}
      </div>
      <p className="mt-3 text-sm text-neutral-600 leading-relaxed">{r.text}</p>
    </div>
  );
}

export function Reviews() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/reviews").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const loop = [...items, ...items];

  return (
    <section id="reviews" className="section-pad overflow-hidden" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal className="text-center">
          <span className="overline">Google Reviews</span>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">
            Loved by learners across <span className="brand-text">the community</span>
          </h2>
          <div className="mt-4 inline-flex items-center gap-2">
            <div className="flex gap-0.5">{Array.from({ length: 5 }).map((_, k) => <Star key={k} size={18} className="fill-brand-amber text-brand-amber" />)}</div>
            <span className="font-semibold">4.9</span>
            <span className="text-neutral-400 text-sm">· 320+ Google reviews</span>
          </div>
        </Reveal>
      </div>

      <div className="mt-12 relative">
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {loop.map((r, i) => <ReviewCard key={i} r={r} />)}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
}
